(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["New-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.showcaseReady === 'true') return;
      section.dataset.showcaseReady = 'true';
      const tabs = [...section.querySelectorAll('[data-showcase-tab]')];
      const panels = [...section.querySelectorAll('[data-showcase-panel]')];
      const previous = section.querySelector('[data-showcase-previous]');
      const next = section.querySelector('[data-showcase-next]');
      const pause = section.querySelector('[data-showcase-pause]');
      const pauseIcon = section.querySelector('[data-showcase-pause-icon]');
      const progress = section.querySelector('[data-showcase-progress]');
      const autoplay = section.dataset.autoplay === 'true';
      const speed = Number(section.dataset.speed) || 6000;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = 0;
      let timer = 0;
      let paused = false;

      const updateProgress = () => {
        if (progress) progress.style.width = `${((active + 1) / panels.length) * 100}%`;
      };

      const activate = (index, focus = false) => {
        active = (index + panels.length) % panels.length;
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === active;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected) tab.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        });
        panels.forEach((panel, panelIndex) => {
          const selected = panelIndex === active;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        updateProgress();
        if (focus) tabs[active]?.focus();
        restart();
      };

      const restart = () => {
        window.clearInterval(timer);
        if (!autoplay || paused || reduced || panels.length < 2) return;
        timer = window.setInterval(() => activate(active + 1), speed);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) activate(index);
        });
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            activate(active + 1, true);
          }
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            activate(active - 1, true);
          }
          if (event.key === 'Home') activate(0, true);
          if (event.key === 'End') activate(tabs.length - 1, true);
        });
      });
      previous?.addEventListener('click', () => activate(active - 1));
      next?.addEventListener('click', () => activate(active + 1));
      pause?.addEventListener('click', () => {
        paused = !paused;
        pause.setAttribute('aria-pressed', String(paused));
        if (pauseIcon) pauseIcon.textContent = paused ? '▶' : 'Ⅱ';
        restart();
      });
      section.addEventListener('mouseenter', () => {
        if (!autoplay) return;
        window.clearInterval(timer);
      });
      section.addEventListener('mouseleave', restart);
      activate(0);
    };
    document.querySelectorAll('[data-tfc-showcase]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-showcase]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__regionalFreeShippingProgress) return;

    const state = {
      refreshTimer: null,
      refreshing: false,
      refreshQueued: false
    };

    window.__regionalFreeShippingProgress = state;

    const BLOCK_SELECTOR = '[data-free-shipping-progress]';
    const CART_MUTATION_PATH = /\/cart\/(add|change|update|clear)(\.js)?\/?$/i;

    const toCodeSet = (value) => new Set((value || '').split(',').filter(Boolean));

    const getRegion = (countryCode, block) => {
      const code = String(countryCode || '').trim().toUpperCase();

      if (code === 'GB') return 'UK';
      if (code === 'US') return 'USA';
      if (toCodeSet(block.dataset.europeCodes).has(code)) return 'Europe';
      if (toCodeSet(block.dataset.africaCodes).has(code)) return 'Africa';
      if (toCodeSet(block.dataset.asiaCodes).has(code)) return 'Asia';
      return 'World';
    };

    const getThreshold = (block, region) => {
      const keyByRegion = {
        UK: 'thresholdUk',
        USA: 'thresholdUsa',
        Europe: 'thresholdEurope',
        Africa: 'thresholdAfrica',
        Asia: 'thresholdAsia',
        World: 'thresholdWorld'
      };
      const key = keyByRegion[region] || keyByRegion.World;
      const threshold = Number(block.dataset[key]);
      return Number.isFinite(threshold) ? threshold : 0;
    };

    const formatMoney = (minorUnits, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency
        }).format(minorUnits / 100);
      } catch (error) {
        return `£${(minorUnits / 100).toFixed(2)}`;
      }
    };

    const updateBlock = (block, cart) => {
      const currency = String(cart.currency || '').toUpperCase();
      const thresholdCurrency = String(block.dataset.thresholdCurrency || '').toUpperCase();

      if (!currency || currency !== thresholdCurrency) {
        block.hidden = true;
        return;
      }

      const country = window.Shopify?.country || block.dataset.country;
      const region = getRegion(country, block);
      const threshold = getThreshold(block, region);
      const cartTotal = Math.max(Number(cart.total_price) || 0, 0);
      const message = block.querySelector('[data-free-shipping-message]');
      const bar = block.querySelector('[data-free-shipping-bar]');
      const track = block.querySelector('[data-free-shipping-track]');

      if (!threshold || !message || !bar || !track) {
        block.hidden = true;
        return;
      }

      const remaining = Math.max(threshold - cartTotal, 0);
      const progress = Math.min(Math.max((cartTotal / threshold) * 100, 0), 100);

      block.hidden = false;
      block.dataset.region = region;

      if (remaining > 0) {
        const template = block.dataset.progressMessage || "You're [amount] away from free shipping";
        message.textContent = template.replace('[amount]', formatMoney(remaining, currency));
      } else {
        message.textContent = block.dataset.successMessage || "You've unlocked free shipping!";
      }

      bar.style.width = `${progress}%`;
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
    };

    const updateAll = (cart) => {
      document.querySelectorAll(BLOCK_SELECTOR).forEach((block) => updateBlock(block, cart));
    };

    const fetchCart = async () => {
      if (state.refreshing) {
        state.refreshQueued = true;
        return;
      }

      state.refreshing = true;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await window.fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });

        if (response.ok) updateAll(await response.json());
      } catch (error) {
        // Keep the server-rendered state if the cart request fails.
      } finally {
        state.refreshing = false;

        if (state.refreshQueued) {
          state.refreshQueued = false;
          scheduleRefresh(0);
        }
      }
    };

    const scheduleRefresh = (delay = 80) => {
      window.clearTimeout(state.refreshTimer);
      state.refreshTimer = window.setTimeout(fetchCart, delay);
    };

    const isCartMutation = (input, init) => {
      try {
        const requestMethod = input instanceof Request ? input.method : undefined;
        const method = String(init?.method || requestMethod || 'GET').toUpperCase();
        const requestUrl = input instanceof Request ? input.url : input;
        const path = new URL(String(requestUrl), window.location.origin).pathname;
        return method !== 'GET' && CART_MUTATION_PATH.test(path);
      } catch (error) {
        return false;
      }
    };

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const watchesCart = isCartMutation(args[0], args[1]);
      const request = Reflect.apply(originalFetch, this, args);

      if (watchesCart) {
        request.then((response) => {
          if (response.ok) scheduleRefresh();
        }).catch(() => {});
      }

      return request;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__freeShippingCartMutation = isCartMutation(url, { method });
      return Reflect.apply(originalOpen, this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      if (this.__freeShippingCartMutation) {
        this.addEventListener('loadend', () => {
          if (this.status >= 200 && this.status < 300) scheduleRefresh();
        }, { once: true });
      }

      return Reflect.apply(originalSend, this, args);
    };

    [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'cart-drawer:refresh',
      'product:added',
      'ajaxProduct:added',
      'theme:cart:change'
    ].forEach((eventName) => {
      document.addEventListener(eventName, (event) => {
        const eventCart = event.detail?.cart;
        if (eventCart && typeof eventCart.total_price !== 'undefined') {
          updateAll(eventCart);
        } else {
          scheduleRefresh();
        }
      });
    });

    document.addEventListener('shopify:block:load', () => scheduleRefresh(0));

    document.addEventListener('submit', (event) => {
      if (event.target.matches('form[action*="/cart/add"], form[action$="/cart"]')) {
        scheduleRefresh(500);
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('form[action$="/cart"]')) scheduleRefresh(350);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleRefresh(0), { once: true });
    } else {
      scheduleRefresh(0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.storyReady === 'true') return;
      section.dataset.storyReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced) section.classList.add('tfc-story--motion');

      const reveals = [...section.querySelectorAll('[data-story-reveal]')];
      if (reduced) {
        reveals.forEach((item) => item.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach((item) => revealObserver.observe(item));
      }

      const chapters = [...section.querySelectorAll('[data-story-chapter]')];
      const images = [...section.querySelectorAll('[data-story-image]')];
      const current = section.querySelector('[data-story-current]');
      const activate = (index) => {
        images.forEach((image, imageIndex) => {
          const active = imageIndex === index;
          image.hidden = false;
          image.classList.toggle('is-active', active);
          if (!active) window.setTimeout(() => { if (!image.classList.contains('is-active')) image.hidden = true; }, 850);
        });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      if (chapters.length) {
        const chapterObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) activate(Number(entry.target.dataset.storyChapter));
          });
        }, { threshold: .52 });
        chapters.forEach((chapter) => chapterObserver.observe(chapter));
      }

      if (!reduced) {
        const layers = [...section.querySelectorAll('[data-story-parallax]')];
        let ticking = false;
        const update = () => {
          layers.forEach((layer) => {
            const rect = layer.parentElement.getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight));
            layer.style.transform = `translate3d(0, ${progress * 42}px, 0) scale(1.04)`;
          });
          ticking = false;
        };
        const request = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        };
        window.addEventListener('scroll', request, { passive: true });
        window.addEventListener('resize', request);
        update();
      }
    };
    document.querySelectorAll('[data-tfc-story]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-story]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-100collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tfc-collection-rail')) {
    class TfcCollectionRail extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        this.progress = this.querySelector('[data-rail-progress]');

        if (!this.rail) return;

        this.onScroll = () => {
          window.requestAnimationFrame(() => this.update());
        };
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onKeydown = (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        };
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        };

        this.rail.addEventListener('scroll', this.onScroll, { passive: true });
        this.rail.addEventListener('keydown', this.onKeydown);
        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.rail);
        this.update();
      }

      disconnectedCallback() {
        this.rail?.removeEventListener('scroll', this.onScroll);
        this.rail?.removeEventListener('keydown', this.onKeydown);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        const card = this.rail.querySelector('[data-rail-card]');
        if (!card) return;

        const styles = window.getComputedStyle(this.rail);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.rail.scrollBy({ left: distance * direction, behavior });
      }

      update() {
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const current = Math.min(maximum, Math.max(0, this.rail.scrollLeft));
        const visibleRatio = this.rail.scrollWidth > 0
          ? Math.min(1, (current + this.rail.clientWidth) / this.rail.scrollWidth)
          : 1;

        if (this.progress) {
          this.progress.style.setProperty('--tfc-progress', visibleRatio);
        }
        if (this.previous) {
          this.previous.disabled = current <= 2;
        }
        if (this.next) {
          this.next.disabled = current >= maximum - 2;
        }
      }
    }

    customElements.define('tfc-collection-rail', TfcCollectionRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-brand-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tfc-brand-slider')) {
    class TfcBrandSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.delay = Number(this.dataset.delay) || 7000;
        this.paused = false;
        this.pointerStart = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previousButton?.addEventListener('click', () => this.show(this.current - 1, true));
        this.nextButton?.addEventListener('click', () => this.show(this.current + 1, true));
        this.pauseButton?.addEventListener('click', () => this.togglePause());

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true));
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.addEventListener('pointerdown', (event) => {
          this.pointerStart = { x: event.clientX, y: event.clientY };
        });
        this.addEventListener('pointerup', (event) => this.handleSwipe(event));

        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      handleVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      handleBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const selectedSlide = event.target.closest('[data-slide]');
        if (!selectedSlide) return;
        this.show(Number(selectedSlide.dataset.index), false);
        this.stop();
      };

      handleSwipe(event) {
        if (!this.pointerStart) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        this.show(deltaX < 0 ? this.current + 1 : this.current - 1, true);
      }

      show(index, userInitiated = false) {
        if (this.slides.length < 2) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;
        if (nextIndex === this.current) return;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.hidden = false;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (!active) {
            window.setTimeout(() => {
              if (!slide.classList.contains('is-active')) slide.hidden = true;
            }, this.reducedMotion ? 0 : 720);
          }
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        this.current = nextIndex;
        if (userInitiated) this.restart();
      }

      start() {
        if (!this.autoplayEnabled || this.paused || this.reducedMotion || this.slides.length < 2 || document.hidden) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.current + 1), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      togglePause() {
        this.paused = !this.paused;
        this.classList.toggle('is-paused', this.paused);
        if (this.pauseButton) {
          const label = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
          this.pauseButton.setAttribute('aria-label', label);
        }
        if (this.paused) this.stop();
        else this.start();
      }
    }

    customElements.define('tfc-brand-slider', TfcBrandSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-bundle-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.tbReady === 'true') return;
      root.dataset.tbReady = 'true';

      let data = {};
      try { data = JSON.parse(root.querySelector('[data-tfc-bundle-data]').textContent); } catch (e) {}

      const $$ = (sel) => [...root.querySelectorAll(sel)];
      const idInput = root.querySelector('[data-tb-id]');
      const form = root.querySelector('[data-tb-form]');
      const addBtn = root.querySelector('[data-tb-add]');
      const addLabel = root.querySelector('[data-tb-add-label]');
      const labels = { add: root.dataset.addLabel || '', sold: root.dataset.soldLabel || '' };

      const clean = (val) => String(val == null ? '' : val).replace(/<[^>]*>/g, '');
      const setText = (sel, val) => $$(sel).forEach((el) => { el.textContent = clean(val); });
      const toggle = (sel, show) => $$(sel).forEach((el) => { el.hidden = !show; });

      const update = (id) => {
        const v = data[id];
        if (!v) return;
        if (idInput) idInput.value = id;
        setText('[data-tb-price]', v.price);
        setText('[data-tb-add-price]', v.price);
        setText('[data-tb-save]', v.save);
        setText('[data-tb-pct]', v.pct);
        setText('[data-tb-total]', v.total);
        setText('[data-tb-per]', v.perBook);
        const saving = v.saveCents > 0;
        toggle('[data-tb-saving]', saving);
        toggle('[data-tb-badge]', saving);
        toggle('[data-tb-stat-save]', saving);
        toggle('[data-tb-stat-pct]', saving);
        toggle('[data-tb-included-sub]', saving);
        toggle('[data-tb-total-box]', saving);
        toggle('[data-tb-sticky-save]', saving);
        const was = root.querySelector('[data-tb-was]');
        if (was) {
          if (saving) { was.textContent = clean(v.total); was.hidden = false; }
          else if (v.hasCompare) { was.textContent = clean(v.compare); was.hidden = false; }
          else { was.hidden = true; }
        }
        $$('[data-tb-book]').forEach((card) => {
          const p = card.dataset['p' + v.fmt.charAt(0).toUpperCase() + v.fmt.slice(1)] || card.dataset.pAny;
          const el = card.querySelector('[data-tb-book-price]');
          if (el && p) el.textContent = clean(p);
        });
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? labels.add : labels.sold;
        $$('[data-tb-proxy-add]').forEach((b) => { b.disabled = !v.available; });
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      };

      $$('[data-tb-variant]').forEach((radio) => radio.addEventListener('change', () => update(radio.value)));

      const qty = root.querySelector('[data-tb-qty]');
      root.querySelector('[data-tb-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      root.querySelector('[data-tb-plus]')?.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      $$('[data-tb-proxy-add]').forEach((btn) => btn.addEventListener('click', () => {
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn?.click();
      }));

      // Gallery
      const track = root.querySelector('[data-tb-track]');
      const thumbs = $$('[data-tb-thumb]');
      if (track && thumbs.length) {
        thumbs.forEach((t) => t.addEventListener('click', () => {
          track.scrollTo({ left: track.clientWidth * parseInt(t.dataset.tbThumb, 10), behavior: 'smooth' });
        }));
        let raf;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          });
        }, { passive: true });
      }

      // Sticky bar: show once the main add button has scrolled above the viewport
      const sticky = root.querySelector('[data-tb-sticky]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelectorAll('button').forEach((b) => b.tabIndex = show ? 0 : -1);
        }).observe(addBtn);
      }
    };

    document.querySelectorAll('[data-tfc-bundle]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-tfc-bundle]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-cinematic-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tfc-cinematic-slider')) {
    class TfcCinematicSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-cinema-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-cinema-dot]'));
        this.previous = this.querySelector('[data-cinema-previous]');
        this.next = this.querySelector('[data-cinema-next]');
        this.pause = this.querySelector('[data-cinema-pause]');
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.delay = Number(this.dataset.delay) || 7500;
        this.isPaused = false;
        this.dragStart = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previous?.addEventListener('click', () => this.go(this.current - 1, true));
        this.next?.addEventListener('click', () => this.go(this.current + 1, true));
        this.pause?.addEventListener('click', () => this.togglePause());
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.cinemaDot), true)));

        this.addEventListener('pointerdown', (event) => {
          this.dragStart = { x: event.clientX, y: event.clientY };
        });
        this.addEventListener('pointerup', (event) => this.onSwipe(event));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });

        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('[data-cinema-slide]');
        if (!slide) return;
        this.go(Number(slide.dataset.index), false);
        this.stop();
      };

      onSwipe(event) {
        if (!this.dragStart) return;
        const x = event.clientX - this.dragStart.x;
        const y = event.clientY - this.dragStart.y;
        this.dragStart = null;
        if (Math.abs(x) < 50 || Math.abs(x) < Math.abs(y)) return;
        this.go(x < 0 ? this.current + 1 : this.current - 1, true);
      }

      go(index, manual = false) {
        if (this.slides.length < 2) return;
        const target = (index + this.slides.length) % this.slides.length;
        if (target === this.current) return;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === target;
          slide.hidden = false;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (!active) {
            window.setTimeout(() => {
              if (!slide.classList.contains('is-active')) slide.hidden = true;
            }, this.reducedMotion ? 0 : 820);
          }
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === target;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        this.current = target;
        if (manual) this.restart();
      }

      start() {
        if (!this.autoplay || this.isPaused || this.reducedMotion || this.slides.length < 2 || document.hidden) return;
        this.stop();
        this.timer = window.setInterval(() => this.go(this.current + 1), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      togglePause() {
        this.isPaused = !this.isPaused;
        this.classList.toggle('is-paused', this.isPaused);
        if (this.pause) {
          const label = this.isPaused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel;
          this.pause.setAttribute('aria-label', label);
        }
        if (this.isPaused) this.stop();
        else this.start();
      }
    }

    customElements.define('tfc-cinematic-slider', TfcCinematicSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.tfcCollectionsReady === 'true') return;
      section.dataset.tfcCollectionsReady = 'true';
      const viewport = section.querySelector('[data-tfc-viewport]');
      const cards = [...section.querySelectorAll('[data-tfc-card]')];
      const previous = section.querySelector('[data-tfc-previous]');
      const next = section.querySelector('[data-tfc-next]');
      const current = section.querySelector('[data-tfc-current]');
      const progress = section.querySelector('[data-tfc-progress]');
      if (!viewport || !cards.length) return;

      const activeIndex = () => {
        const viewportLeft = viewport.getBoundingClientRect().left;
        let bestIndex = 0;
        let bestDistance = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        return bestIndex;
      };

      const update = () => {
        const index = activeIndex();
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.width = `${((index + 1) / cards.length) * 100}%`;
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === cards.length - 1;
      };

      const move = (direction) => {
        const index = activeIndex();
        const target = Math.max(0, Math.min(cards.length - 1, index + direction));
        cards[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      let frame = 0;
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    document.querySelectorAll('[data-tfc-collections]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-collections]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-collection-carousel2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.tfcCollectionsReady === 'true') return;
      section.dataset.tfcCollectionsReady = 'true';
      const viewport = section.querySelector('[data-tfc-viewport]');
      const cards = [...section.querySelectorAll('[data-tfc-card]')];
      const previous = section.querySelector('[data-tfc-previous]');
      const next = section.querySelector('[data-tfc-next]');
      const current = section.querySelector('[data-tfc-current]');
      const progress = section.querySelector('[data-tfc-progress]');
      if (!viewport || !cards.length) return;

      const activeIndex = () => {
        const viewportLeft = viewport.getBoundingClientRect().left;
        let bestIndex = 0;
        let bestDistance = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        return bestIndex;
      };

      const update = () => {
        const index = activeIndex();
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.width = `${((index + 1) / cards.length) * 100}%`;
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === cards.length - 1;
      };

      const move = (direction) => {
        const index = activeIndex();
        const target = Math.max(0, Math.min(cards.length - 1, index + direction));
        cards[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      let frame = 0;
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    document.querySelectorAll('[data-tfc-collections]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-collections]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tfc-logo-carousel')) {
    class TfcLogoCarousel extends HTMLElement {
      connectedCallback() {
        this.pauseButton = this.querySelector('[data-logo-pause]');
        this.pauseButton?.addEventListener('click', this.toggle);
      }

      disconnectedCallback() {
        this.pauseButton?.removeEventListener('click', this.toggle);
      }

      toggle = () => {
        const paused = this.classList.toggle('is-paused');
        if (!this.pauseButton) return;
        const label = paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label', label);
      };
    }

    customElements.define('tfc-logo-carousel', TfcLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-premium-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.tfcProductReady === 'true') return;
      section.dataset.tfcProductReady = 'true';
      const thumbs = [...section.querySelectorAll('[data-tfc-thumb]')];
      const media = [...section.querySelectorAll('[data-tfc-media]')];
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        const id = thumb.dataset.tfcThumb;
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        media.forEach((item) => {
          const active = item.dataset.tfcMedia === id;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
      }));
      const quantity = section.querySelector('[data-tfc-quantity]');
      section.querySelector('[data-tfc-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      section.querySelector('[data-tfc-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
      const variant = section.querySelector('[data-tfc-variant]');
      const price = section.querySelector('[data-tfc-price] strong');
      const stickyPrice = section.querySelector('[data-tfc-sticky-price]');
      const add = section.querySelector('[data-tfc-add]');
      const stickyAdd = section.querySelector('[data-tfc-sticky-add]');
      const stock = section.querySelector('[data-tfc-stock]');
      variant?.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
        if (add) add.disabled = !available;
        if (stickyAdd) stickyAdd.disabled = !available;
        stock?.classList.toggle('is-unavailable', !available);
      });
      stickyAdd?.addEventListener('click', () => add?.click());
    };
    document.querySelectorAll('[data-tfc-product-page]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-product-page]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfc-who-we-are-"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.storyReady === 'true') return;
      section.dataset.storyReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced) section.classList.add('tfc-story--motion');

      const reveals = [...section.querySelectorAll('[data-story-reveal]')];
      if (reduced) {
        reveals.forEach((item) => item.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach((item) => revealObserver.observe(item));
      }

      const chapters = [...section.querySelectorAll('[data-story-chapter]')];
      const images = [...section.querySelectorAll('[data-story-image]')];
      const current = section.querySelector('[data-story-current]');
      const activate = (index) => {
        images.forEach((image, imageIndex) => {
          const active = imageIndex === index;
          image.hidden = false;
          image.classList.toggle('is-active', active);
          if (!active) window.setTimeout(() => { if (!image.classList.contains('is-active')) image.hidden = true; }, 850);
        });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      if (chapters.length) {
        const chapterObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) activate(Number(entry.target.dataset.storyChapter));
          });
        }, { threshold: .52 });
        chapters.forEach((chapter) => chapterObserver.observe(chapter));
      }

      if (!reduced) {
        const layers = [...section.querySelectorAll('[data-story-parallax]')];
        let ticking = false;
        const update = () => {
          layers.forEach((layer) => {
            const rect = layer.parentElement.getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight));
            layer.style.transform = `translate3d(0, ${progress * 42}px, 0) scale(1.04)`;
          });
          ticking = false;
        };
        const request = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        };
        window.addEventListener('scroll', request, { passive: true });
        window.addEventListener('resize', request);
        update();
      }
    };
    document.querySelectorAll('[data-tfc-story]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tfc-story]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
